<template>
  <slot />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'before-create',
  props: {
    do: {
      type: Function,
      required: true
    }
  },
  beforeCreate() {
    this.do()
  }
})
</script>
